import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb0c9964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 新增玻璃架 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 刷新列表 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("报废")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("丢失")
const _hoisted_8 = { class: "editable-cell" }
const _hoisted_9 = {
  key: 0,
  class: "editable-cell-input-wrapper"
}
const _hoisted_10 = {
  key: 1,
  class: "editable-cell-text-wrapper"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("报废")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("遗失")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 借出 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 归还 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 新增 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 新增 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_check_outlined = _resolveComponent("check-outlined")!
  const _component_edit_outlined = _resolveComponent("edit-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_MobileOutlined = _resolveComponent("MobileOutlined")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_page_header, {
      class: "demo-page-header",
      style: {"border":"1px solid rgb(235, 237, 240)","margin-bottom":"8px"},
      title: `玻璃架(${_ctx.frameListSearch.length}/${_ctx.frameList.length})`,
      "sub-title": "查询/跟踪补片进度"
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "1",
          type: "primary",
          onClick: _ctx.handleNewFrameVisible
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "2",
          style: {"background-color":"#52c41a","color":"#fff"},
          onClick: _ctx.getFrameList
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          size: "small",
          column: 3
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "玻璃架状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.frameValue,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frameValue) = $event)),
                  "button-style": "solid"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_button, { value: "all" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_button, { value: "normal" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_button, { value: "scrap" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_button, { value: "lose" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "使用者" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  style: {"width":"160px"},
                  value: _ctx.useValue,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.useValue) = $event)),
                  placeholder: "请选择",
                  dropdownMatchSelectWidth: false,
                  "show-search": "",
                  onSearch: _ctx.handleSearchClient
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useListSearch, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item,
                        key: item
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onSearch"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_a_table, {
      columns: _ctx.frameColumns,
      "row-key": (record) => record.frame_id,
      "data-source": _ctx.frameListSearch,
      loading: _ctx.frameLoading,
      pagination: false,
      size: "small"
    }, {
      frame_name: _withCtx(({ text, record }) => [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.frameNameEditableData[record.frame_id])
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_a_input, {
                  value: _ctx.frameNameEditableData[record.frame_id].frame_name,
                  "onUpdate:value": ($event: any) => ((_ctx.frameNameEditableData[record.frame_id].frame_name) = $event),
                  onPressEnter: ($event: any) => (_ctx.frameNameSave(record.frame_id, record.frame_name))
                }, null, 8, ["value", "onUpdate:value", "onPressEnter"]),
                _createVNode(_component_check_outlined, {
                  class: "editable-cell-icon-check",
                  onClick: ($event: any) => (_ctx.frameNameSave(record.frame_id, record.frame_name))
                }, null, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(text || " ") + " ", 1),
                _createVNode(_component_edit_outlined, {
                  class: "editable-cell-icon",
                  onClick: ($event: any) => (_ctx.frameNameEdit(record.frame_id))
                }, null, 8, ["onClick"])
              ]))
        ])
      ]),
      user_name: _withCtx(({ text }) => [
        _createVNode(_component_a_tag, {
          color: text === _ctx.company_mini_name ? 'green' : 'orange'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(text), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]),
      partition_name: _withCtx(({ text }) => [
        _createVNode(_component_a_tag, {
          color: text === '' ? 'default' : '#52C41A'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(text === "" ? "-" : text), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]),
      place_x: _withCtx(({ text }) => [
        (text < 0)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "#FF7875"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "#52C41A"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              _: 2
            }, 1024))
      ]),
      place_y: _withCtx(({ text }) => [
        (text < 0)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "#FF7875"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "#52C41A"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              _: 2
            }, 1024))
      ]),
      place_z: _withCtx(({ text }) => [
        (text < 0)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "#FF7875"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "#52C41A"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              _: 2
            }, 1024))
      ]),
      is_states: _withCtx(({ text }) => [
        (text === 0)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "default"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (text === 1)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (text === 2)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              color: "warning"
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (text === 3)
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              color: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      operation: _withCtx(({ text, record }) => [
        (record.user_name === _ctx.company_mini_name)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              style: {"background-color":"#52c41a","color":"#fff"},
              onClick: ($event: any) => (_ctx.handleLendFrameVisible(text))
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              onClick: ($event: any) => (_ctx.handleNewFrameVisible(text))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 2
            }, 1032, ["onClick"]))
      ]),
      _: 1
    }, 8, ["columns", "row-key", "data-source", "loading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.newFrameVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newFrameVisible) = $event)),
      title: "新增玻璃架"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.handleCancelNewFrame
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: _ctx.newFrameLoading,
          onClick: _ctx.handleOkNewFrame
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: _ctx.newFrameNameValue,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newFrameNameValue) = $event)),
          placeholder: "请输入你要新增的玻璃架名称",
          "allow-clear": ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.lendFrameVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.lendFrameVisible) = $event)),
      title: "借出玻璃架"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.handleCancelNewFrame
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: _ctx.newFrameLoading,
          onClick: _ctx.handleOkNewFrame
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({
          ref: "lendFrameFormRef",
          model: _ctx.lendFrameModel,
          rules: _ctx.lendFrameRules
        }, _ctx.lendFrameLayout, { layout: "horizontal" }), {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "客户名称",
              "has-feedback": "",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  style: {"width":"160px"},
                  value: _ctx.userValue,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userValue) = $event)),
                  placeholder: "请选择",
                  dropdownMatchSelectWidth: false,
                  "show-search": "",
                  onSearch: _ctx.handleSearchUser
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userListSearch, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item,
                        key: item
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.user_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onSearch"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "借出玻璃架名称",
              name: "delivery"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  mode: "multiple",
                  value: _ctx.lendFrameValue,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lendFrameValue) = $event)),
                  placeholder: "请选择需要借出的玻璃架",
                  onChange: _ctx.handleChangeLendFrame
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lendFrameList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.frame_id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.frame_name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "押金/个",
              "has-feedback": "",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  type: "text",
                  placeholder: "请输入押金金额"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_MobileOutlined, { style: {"color":"#1890ff"} })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}